import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('authToken');

  if (!token || req.headers.has('Authorization')) {
    return next(req);
  }

  const authenticatedRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });

  const router = inject(Router);
  const authService = inject(AuthService);

  return next(authenticatedRequest).pipe(
    catchError((error) => {
      if (error.status === 401 && !req.url.includes('/auth/refresh') && !req.url.includes('/auth/logout')) {
        return authService.refreshAccessToken().pipe(
          switchMap((response) => {
            const retryRequest = req.clone({
              setHeaders: { Authorization: `Bearer ${response.token}` }
            });
            return next(retryRequest);
          }),
          catchError((refreshError) => {
            authService.logout();
            router.navigate(['/auth/login'], {
              queryParams: { returnUrl: router.url, sessionExpired: true }
            });
            return throwError(() => refreshError);
          })
        );
      }

      if (error.status === 403) {
        authService.logout();
        router.navigate(['/auth/login'], {
          queryParams: { returnUrl: router.url, sessionExpired: true }
        });
      }

      return throwError(() => error);
    })
  );
};
